/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  ContactNote,
  ContactNoteCreateRequest,
  DocumentationContactNotesListParams,
  DocumentationContactNotesPlacesOfServiceRetrieveParams,
  DocumentationOrgServiceTypesListParams,
  DocumentationServiceTypesListParams,
  DocumentationSessionDocumentsListParams,
  DocumentationSessionDocumentsPdfRetrieve200,
  PaginatedContactNoteList,
  PaginatedV2OrgSessionServiceTypeList,
  PaginatedV2SessionDocumentationList,
  PaginatedV2SessionServiceTypeList,
  PatchedV2SessionDocumentationRequest,
  PlaceOfServiceCatalog,
  V2SessionDocumentation,
  V2SessionDocumentationRequest,
  V2SessionServiceType
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Contact notes on members the caller can see.
 */
export const documentationContactNotesList = (
    params?: DocumentationContactNotesListParams,
 options?: SecondParameter<typeof apiV2<PaginatedContactNoteList>>,) => {
      return apiV2<PaginatedContactNoteList>(
      {url: `/documentation/contact-notes/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Creates a contact note on a member the caller can see.
 */
export const documentationContactNotesCreate = (
    contactNoteCreateRequest: ContactNoteCreateRequest,
 options?: SecondParameter<typeof apiV2<ContactNote>>,) => {
      return apiV2<ContactNote>(
      {url: `/documentation/contact-notes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contactNoteCreateRequest
    },
      options);
    }
  /**
 * Contact notes on members the caller can see.
 */
export const documentationContactNotesRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<ContactNote>>,) => {
      return apiV2<ContactNote>(
      {url: `/documentation/contact-notes/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * The AHCCCS places of service in effect on the date of service that every service code allows.
 */
export const documentationContactNotesPlacesOfServiceRetrieve = (
    params?: DocumentationContactNotesPlacesOfServiceRetrieveParams,
 options?: SecondParameter<typeof apiV2<PlaceOfServiceCatalog>>,) => {
      return apiV2<PlaceOfServiceCatalog>(
      {url: `/documentation/contact-notes/places-of-service/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Service types enabled for an org.
 *
 * Org-scoped via ``X-Org-ID``. List-only — bridge just renders the enabled
 * types; the catalog is authored in Django admin.
 */
export const documentationOrgServiceTypesList = (
    params?: DocumentationOrgServiceTypesListParams,
 options?: SecondParameter<typeof apiV2<PaginatedV2OrgSessionServiceTypeList>>,) => {
      return apiV2<PaginatedV2OrgSessionServiceTypeList>(
      {url: `/documentation/org-service-types/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Read-only access to the global service-type catalog.
 *
 * The catalog is global, so there's no org filtering — but it's still staff-only.
 * Writes stay in Django admin.
 */
export const documentationServiceTypesList = (
    params?: DocumentationServiceTypesListParams,
 options?: SecondParameter<typeof apiV2<PaginatedV2SessionServiceTypeList>>,) => {
      return apiV2<PaginatedV2SessionServiceTypeList>(
      {url: `/documentation/service-types/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Read-only access to the global service-type catalog.
 *
 * The catalog is global, so there's no org filtering — but it's still staff-only.
 * Writes stay in Django admin.
 */
export const documentationServiceTypesRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<V2SessionServiceType>>,) => {
      return apiV2<V2SessionServiceType>(
      {url: `/documentation/service-types/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Session documents CRUD + PDF, org-scoped and staff-only.
 *
 * Permission filtering happens at the queryset level via
 * ``Member.objects.filter_members_by_role()`` so pagination counts stay correct.
 * Revert lives in ``RevertDocumentService`` / ``CanModifyDocument``.
 */
export const documentationSessionDocumentsList = (
    params?: DocumentationSessionDocumentsListParams,
 options?: SecondParameter<typeof apiV2<PaginatedV2SessionDocumentationList>>,) => {
      return apiV2<PaginatedV2SessionDocumentationList>(
      {url: `/documentation/session-documents/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Session documents CRUD + PDF, org-scoped and staff-only.
 *
 * Permission filtering happens at the queryset level via
 * ``Member.objects.filter_members_by_role()`` so pagination counts stay correct.
 * Revert lives in ``RevertDocumentService`` / ``CanModifyDocument``.
 */
export const documentationSessionDocumentsCreate = (
    v2SessionDocumentationRequest: V2SessionDocumentationRequest,
 options?: SecondParameter<typeof apiV2<V2SessionDocumentation>>,) => {
      return apiV2<V2SessionDocumentation>(
      {url: `/documentation/session-documents/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: v2SessionDocumentationRequest
    },
      options);
    }
  /**
 * Session documents CRUD + PDF, org-scoped and staff-only.
 *
 * Permission filtering happens at the queryset level via
 * ``Member.objects.filter_members_by_role()`` so pagination counts stay correct.
 * Revert lives in ``RevertDocumentService`` / ``CanModifyDocument``.
 */
export const documentationSessionDocumentsRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<V2SessionDocumentation>>,) => {
      return apiV2<V2SessionDocumentation>(
      {url: `/documentation/session-documents/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Session documents CRUD + PDF, org-scoped and staff-only.
 *
 * Permission filtering happens at the queryset level via
 * ``Member.objects.filter_members_by_role()`` so pagination counts stay correct.
 * Revert lives in ``RevertDocumentService`` / ``CanModifyDocument``.
 */
export const documentationSessionDocumentsUpdate = (
    id: string,
    v2SessionDocumentationRequest: V2SessionDocumentationRequest,
 options?: SecondParameter<typeof apiV2<V2SessionDocumentation>>,) => {
      return apiV2<V2SessionDocumentation>(
      {url: `/documentation/session-documents/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: v2SessionDocumentationRequest
    },
      options);
    }
  /**
 * Session documents CRUD + PDF, org-scoped and staff-only.
 *
 * Permission filtering happens at the queryset level via
 * ``Member.objects.filter_members_by_role()`` so pagination counts stay correct.
 * Revert lives in ``RevertDocumentService`` / ``CanModifyDocument``.
 */
export const documentationSessionDocumentsPartialUpdate = (
    id: string,
    patchedV2SessionDocumentationRequest?: PatchedV2SessionDocumentationRequest,
 options?: SecondParameter<typeof apiV2<V2SessionDocumentation>>,) => {
      return apiV2<V2SessionDocumentation>(
      {url: `/documentation/session-documents/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedV2SessionDocumentationRequest
    },
      options);
    }
  /**
 * Session documents CRUD + PDF, org-scoped and staff-only.
 *
 * Permission filtering happens at the queryset level via
 * ``Member.objects.filter_members_by_role()`` so pagination counts stay correct.
 * Revert lives in ``RevertDocumentService`` / ``CanModifyDocument``.
 */
export const documentationSessionDocumentsDestroy = (
    id: string,
 options?: SecondParameter<typeof apiV2<void>>,) => {
      return apiV2<void>(
      {url: `/documentation/session-documents/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Returns a flat {filename, file} object where file is base64-encoded PDF.
 * @summary Session document PDF
 */
export const documentationSessionDocumentsPdfRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<DocumentationSessionDocumentsPdfRetrieve200>>,) => {
      return apiV2<DocumentationSessionDocumentsPdfRetrieve200>(
      {url: `/documentation/session-documents/${id}/pdf/`, method: 'GET'
    },
      options);
    }
  export type DocumentationContactNotesListResult = NonNullable<Awaited<ReturnType<typeof documentationContactNotesList>>>
export type DocumentationContactNotesCreateResult = NonNullable<Awaited<ReturnType<typeof documentationContactNotesCreate>>>
export type DocumentationContactNotesRetrieveResult = NonNullable<Awaited<ReturnType<typeof documentationContactNotesRetrieve>>>
export type DocumentationContactNotesPlacesOfServiceRetrieveResult = NonNullable<Awaited<ReturnType<typeof documentationContactNotesPlacesOfServiceRetrieve>>>
export type DocumentationOrgServiceTypesListResult = NonNullable<Awaited<ReturnType<typeof documentationOrgServiceTypesList>>>
export type DocumentationServiceTypesListResult = NonNullable<Awaited<ReturnType<typeof documentationServiceTypesList>>>
export type DocumentationServiceTypesRetrieveResult = NonNullable<Awaited<ReturnType<typeof documentationServiceTypesRetrieve>>>
export type DocumentationSessionDocumentsListResult = NonNullable<Awaited<ReturnType<typeof documentationSessionDocumentsList>>>
export type DocumentationSessionDocumentsCreateResult = NonNullable<Awaited<ReturnType<typeof documentationSessionDocumentsCreate>>>
export type DocumentationSessionDocumentsRetrieveResult = NonNullable<Awaited<ReturnType<typeof documentationSessionDocumentsRetrieve>>>
export type DocumentationSessionDocumentsUpdateResult = NonNullable<Awaited<ReturnType<typeof documentationSessionDocumentsUpdate>>>
export type DocumentationSessionDocumentsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof documentationSessionDocumentsPartialUpdate>>>
export type DocumentationSessionDocumentsDestroyResult = NonNullable<Awaited<ReturnType<typeof documentationSessionDocumentsDestroy>>>
export type DocumentationSessionDocumentsPdfRetrieveResult = NonNullable<Awaited<ReturnType<typeof documentationSessionDocumentsPdfRetrieve>>>
